import { initAccordion } from "./modules/accordion/init-accordion";
import { initCustomSelect } from "./modules/custom-select/init-custom-select";
import { initHeader } from "./modules/header/init-header";
import { initModals } from "./modules/modal/init-modals";
import { initPhoneMask } from "./modules/init-phone-mask";
import { initPhoneValidation } from "./modules/init-phone-validation";
import { initTabs } from "./modules/tabs/init-tabs";
import { initIntroSlider } from "./modules/sliders/init-intro-slider";
import { initNewsSlider } from "./modules/sliders/init-news-slider";
import { subMenuHandler } from "./modules/submenu-handler";
import { breadcrumbsTextHandler } from "./modules/breadcrumbs/breadcrumbsTextHandler";
import { initProductFancybox } from "./modules/fancybox/init-product-fancybox";
import { intiAccordionHeaderMenu } from "./modules/accordion/init-accordion-header-menu";
import { showMoreBtnHandler } from "./modules/showMoreBtnHandler/showMoreBtnHandler";
import { openMenuHandler } from "./modules/header/open-menu";
import { goTopBtnHandler } from "./modules/goTopBtnHandler/goTopBtnHandler";
import { initProductsSlider } from "./modules/sliders/init-products.slider";
import { initGetProducts } from "./modules/get-products/init-get-products";

window.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initModals();
  initAccordion();
  initTabs();
  breadcrumbsTextHandler();
  openMenuHandler();
  goTopBtnHandler();
  subMenuHandler();
  initIntroSlider();
  initProductsSlider();
  initGetProducts();

  window.addEventListener("load", () => {
    initCustomSelect();
    initPhoneMask();
    initPhoneValidation();
    initNewsSlider();
    initProductFancybox();
    intiAccordionHeaderMenu();
  });
});

showMoreBtnHandler(".products", ".products-card", 8);
showMoreBtnHandler(".news-page-block", ".news-card", 9);
showMoreBtnHandler(".publications", ".publication-card", 9);
showMoreBtnHandler(".permitting-documentation", ".document-card", 9);
